import { render, staticRenderFns } from "./ShiftSupportDialog.vue?vue&type=template&id=397ee2f9"
import script from "./ShiftSupportDialog.vue?vue&type=script&lang=js"
export * from "./ShiftSupportDialog.vue?vue&type=script&lang=js"
import style0 from "./ShiftSupportDialog.vue?vue&type=style&index=0&id=397ee2f9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports